var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.761767 15.912C0.485996 17.0222 0.698128 18.0263 1.34159 18.6697C1.98506 19.3132 2.98915 19.5253 4.09224 19.2283L5.63373 18.8465C6.19942 18.7051 8.70047 16.5293 9.11059 16.1192L16.7392 8.49062C16.7719 8.4673 16.803 8.44103 16.8322 8.41183C16.8614 8.38263 16.8877 8.35149 16.911 8.3188L18.2747 6.95509C19.7172 5.51259 19.7172 3.165 18.2747 1.7225C16.8322 0.280001 14.4846 0.28 13.0421 1.7225L2.11234 12.6522C1.70222 13.0624 1.28503 13.8048 1.1436 14.3705L0.761767 15.912ZM16.3018 6.82079L17.2211 5.9015C18.0767 5.0459 18.0767 3.64583 17.2211 2.79023C16.3655 1.93463 14.9654 1.93463 14.1098 2.79023L13.1905 3.70952L16.3018 6.82079ZM12.1299 4.77018L3.18714 13.7129C2.96794 13.9321 2.6851 14.4271 2.60732 14.7311L2.22548 16.2726C2.07699 16.8595 2.1477 17.3404 2.40933 17.602C2.67096 17.8636 3.15886 17.9273 3.73869 17.7858L5.28018 17.404C5.58424 17.3262 6.07921 17.0434 6.29841 16.8242L15.2412 7.88145L12.1299 4.77018Z",
    fill: "#277FD8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.14cfc340068fe14e2e525d75d96691a1.svg";
export { ForwardRef as ReactComponent };